"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var single_display_logic_html_1 = __importDefault(require("./single-display-logic.html"));
require("./single-display-logic.less");
(function (module) {
    'use strict';
    module.component('prSingleDisplayLogic', {
        templateUrl: single_display_logic_html_1.default,
        controller: 'prSingleDisplayLogicController as $ctrl',
        bindings: {
            singleDisplayLogic: '=',
            sourceId: '<'
        }
    });
})(angular.module('qualtrics.pr'));
